// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";

function execute(result) {
  return {
          reasons: List.map((function (reason) {
                  return {
                          key: String(reason.id),
                          value: reason.reason,
                          text: reason.reason
                        };
                }), result.order_edit_reasons)
        };
}

export {
  execute ,
  
}
/* No side effect */
